import { api, throwApiError } from "../../../api/api";

/** `date` = data civil "AAAA-MM-DD". */
export type SettingType = "boolean" | "number" | "string" | "select" | "date";

/**
 * Uma configuração como o backend a descreve (`GET /system-settings`). A tela é
 * genérica: tipo, limites, rótulo e grupo vêm daqui — chave nova no registro do
 * backend aparece sem mudança no frontend.
 */
export type SettingEntry = {
  key: string;
  group: string;
  /** Subtítulo dentro do grupo (ex.: Ponto → Quiosque). */
  section?: string;
  label: string;
  description: string;
  type: SettingType;
  options?: { value: string; label: string }[];
  nullable?: boolean;
  min?: number;
  max?: number;
  integer?: boolean;
  default: unknown;
  value: unknown;
  isDefault: boolean;
  updatedAt: string | null;
  updatedBy: { id: string; nomeCompleto: string } | null;
};

export const listSystemSettingsApi = async (): Promise<SettingEntry[]> => {
  try {
    const { data } = await api.get<SettingEntry[]>("/system-settings");
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao carregar as configurações.");
    throw error;
  }
};

export const updateSystemSettingApi = async (key: string, value: unknown): Promise<SettingEntry> => {
  try {
    const { data } = await api.patch<SettingEntry>(`/system-settings/${encodeURIComponent(key)}`, { value });
    return data;
  } catch (error) {
    throwApiError(error, "Erro ao salvar a configuração.");
    throw error;
  }
};
